module.exports = __webpack_public_path__ + "static/media/8286ebea-f530-4c7c-bf5d-526532b6f8af - old.bad27513.png";